module.exports = __webpack_public_path__ + "static/media/image_not_found.106db11a.jpg";